import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useColorMode } from "../app/theme/ColorModeContextProvider.tsx";

interface Props {
  width?: number | string;
  height?: number | string;
  src: string;
  srcDarkMode?: string;
  alt?: string;
  onClick?: () => void;
  enableDialog?: boolean;
}

export const ImageBox: React.FC<Props> = ({
  width = "100%",
  height = 250,
  src,
  srcDarkMode = src,
  alt = "Bild",
  onClick,
  enableDialog = true,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { mode } = useColorMode();

  const handleInternalClick = () => {
    if (onClick) {
      onClick(); // externer Handler hat Priorität
    } else if (enableDialog) {
      setDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Box
        onClick={handleInternalClick}
        sx={{
          padding: 0,
          borderRadius: 1,
          display: "flex",
          width,
          height,
          cursor: onClick || enableDialog ? "pointer" : "default",
          overflow: "hidden",
        }}
      >
        <img
          src={mode === "light" ? src : srcDarkMode}
          alt={alt}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: 8,
          }}
        />
      </Box>

      {enableDialog && (
        <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="xl" fullWidth>
          <DialogContent
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={handleDialogClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 1,
              }}
            >
              <CloseIcon />
            </IconButton>
            <Box
              sx={{
                overflow: "auto",
                maxHeight: "100%",
                maxWidth: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img
                src={mode === "light" ? src : srcDarkMode}
                alt={alt + " Groß"}
                style={{
                  transformOrigin: "center",
                  transition: "transform 0.2s ease-in-out",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
